'use client';
import React, { useState, useEffect } from 'react';
import { Box, Radio, RadioGroup, FormControlLabel, Typography } from '@mui/material';
import DrawerCustom from '@/app/components/MUI/CustomDrawer';
import { CheckedRadioButton, UnCheckedRadioButton } from '@/public/icon';
import { useTranslation } from '@/app/hooks/useTranslation';

interface ProductStatusModalProps {
    open: boolean;
    onClose: () => void;
    currentStatus: 'selling' | 'reserved' | 'sold';
    onStatusChange: (status: 'selling' | 'reserved' | 'sold') => void;
}

const ProductStatusModal: React.FC<ProductStatusModalProps> = ({ open, onClose, currentStatus, onStatusChange }) => {
    const { t } = useTranslation();
    const [selectedStatus, setSelectedStatus] = useState<'selling' | 'reserved' | 'sold'>(currentStatus);

    useEffect(() => {
        setSelectedStatus(currentStatus);
    }, [currentStatus]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newStatus = event.target.value as 'selling' | 'reserved' | 'sold';
        setSelectedStatus(newStatus);
        onStatusChange(newStatus);
        onClose();
    };

    const statusOptions = [
        { value: 'selling', label: t('product_selling', '판매 중') },
        { value: 'reserved', label: t('product_reserved', '예약 중') },
        { value: 'sold', label: t('product_sold', '판매 완료') },
    ];

    return (
        <DrawerCustom
            open={open}
            onClose={onClose}
            title={t('change_status', '상태 변경')}
        >
            <Box sx={{ mt: 5, mb: 7.5, px: 5 }}>
                <RadioGroup
                    value={selectedStatus}
                    onChange={handleChange}
                >
                    {statusOptions.map((option) => (
                        <FormControlLabel
                            key={option.value}
                            value={option.value}
                            control={
                                <Radio
                                    icon={<UnCheckedRadioButton />}
                                    checkedIcon={<CheckedRadioButton />}
                                    sx={{ padding: 0, mr: 2.5 }}
                                />
                            }
                            label={
                                <Typography
                                    variant="h2_16Medium"
                                    sx={{
                                        color: '#000',
                                        ml: 1,
                                    }}
                                >
                                    {option.label}
                                </Typography>
                            }
                            sx={{
                                mb: 4,
                                ml: 0,
                                '& .MuiFormControlLabel-label': {
                                    flex: 1,
                                },
                            }}
                        />
                    ))}
                </RadioGroup>
            </Box>
        </DrawerCustom>
    );
};

export default ProductStatusModal;
